import React from 'react';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Recebimentos } from './pages/Recebimentos';
import { ContasAPagar } from './pages/ContasAPagar';
import { DRE } from './pages/DRE';
import { Configuracoes } from './pages/Configuracoes';

// Controle de Acesso para Rotas Privadas
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { signed, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center">Carregando permissões...</div>;
  return signed ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/recebimentos" element={<PrivateRoute><Recebimentos /></PrivateRoute>} />
            <Route path="/contas-a-pagar" element={<PrivateRoute><ContasAPagar /></PrivateRoute>} />
            <Route path="/dre" element={<PrivateRoute><DRE /></PrivateRoute>} />
            <Route path="/configuracoes" element={<PrivateRoute><Configuracoes /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
